import { API_CONFIG } from "../../shared/api/config";
import composeRequest from "../../shared/api/core";


const BASE_URL = API_CONFIG.API_BASE_PATH;

export const API_URLS = {
    businessQueueListUrl:  BASE_URL + 'core/queue-settings/',
    conversionJobsUrl: BASE_URL + 'korona/conversion-jobs/',
};

export const updateException = (data: any) => {
    const URL = API_URLS.businessQueueListUrl + 'korona_db_sync_exceptions/' + `${data.id}/`;
    return composeRequest(URL, 'PUT', JSON.stringify(data));
};

export const RetryException = (data: any) => {
    const URL = API_URLS.businessQueueListUrl + 'korona_db_sync_exceptions/retry/' + `${data.id}/`;
    return composeRequest(URL, 'PUT', data.metadata);
};

export const updateQueue = (data: any) => {
    const URL = API_URLS.businessQueueListUrl + `${data.id}/`;
    return composeRequest(URL, 'PUT', JSON.stringify(data));
};

export const updateQueueCron = (data: any) => {
    const URL = API_URLS.businessQueueListUrl + `${data[0].id}/`;
    return composeRequest(URL, 'PUT', JSON.stringify(data[0]));
};


export const scheduleQueues = (data:any)=>{
    let URL = API_URLS.businessQueueListUrl + `schedule/`;
    return composeRequest(URL, 'POST', JSON.stringify(data));
}

export const runQueues = (data:any)=>{
    const URL = API_URLS.businessQueueListUrl + `run_now/`;
    return composeRequest(URL, 'POST', JSON.stringify(data));
}

export const getPrefectRuns = (bqsId: number, limit?: number) => {
    const q = limit != null ? `?limit=${limit}` : '';
    const URL = API_URLS.businessQueueListUrl + `${bqsId}/prefect-runs/` + q;
    return composeRequest(URL, 'GET', null);
};

export const postPrefectRun = (bqsId: number, parameters?: Record<string, unknown>) => {
    const URL = API_URLS.businessQueueListUrl + `${bqsId}/prefect-run/`;
    const body = parameters != null ? JSON.stringify({ parameters }) : JSON.stringify({});
    return composeRequest(URL, 'POST', body);
};

export const postPrefectRunRetry = (bqsId: number, flowRunId: string) => {
    const URL = API_URLS.businessQueueListUrl + `${bqsId}/prefect-run-retry/`;
    return composeRequest(URL, 'POST', JSON.stringify({ flow_run_id: flowRunId }));
};

export const postPrefectDeploy = (bqsId: number) => {
    const URL = API_URLS.businessQueueListUrl + `${bqsId}/prefect-deploy/`;
    return composeRequest(URL, 'POST', null);
};

export const getExceptionsByPage = (page: number, pageSize: number, searchTerm: string | null, orderBy: string | null) => {
    let URL = API_URLS.businessQueueListUrl + `korona_db_sync_exceptions/?page=${page}&page_size=${pageSize}`;
    // searchTerm = searchTerm ? searchTerm.trim() : '';
    // if (searchTerm) {
    //     URL = BASE_URL + `search=${searchTerm}&page=${page}&page_size=${pageSize}`;
    // }
    // if (orderBy) {
    //     URL = `${URL}&orderBy=${orderBy}`;
    // }
    return composeRequest(URL, 'GET', JSON.stringify({}));
};

export const retryAll = () => {
    let URL = API_URLS.businessQueueListUrl + 'korona_db_sync_retry_all_exceptions/';
    // searchTerm = searchTerm ? searchTerm.trim() : '';
    // if (searchTerm) {
    //     URL = BASE_URL + `search=${searchTerm}&page=${page}&page_size=${pageSize}`;
    // }
    // if (orderBy) {
    //     URL = `${URL}&orderBy=${orderBy}`;
    // }
    return composeRequest(URL, 'POST', null);
};

export const getBusinessQueues = (
    page: number,
    pageSize: number,
    searchTerm: string | null,
    selectedBusines: string| number,
    selectedTask: string| null,
    orderBy?: string | number

) => {
    let URL = API_URLS.businessQueueListUrl + `?page=${page}&page_size=${pageSize}`;
    if (selectedBusines) {
        URL = `${URL}&business=${selectedBusines}`;
    }
    if (selectedTask) {
        URL = `${URL}&queue=${selectedTask}`;
    }
    searchTerm = searchTerm ? searchTerm.trim() : '';
    if (searchTerm) {
        URL = API_URLS.businessQueueListUrl + `?search=${searchTerm}&page=${page}&page_size=${pageSize}`;
    }
    if (orderBy) {
        URL = `${URL}&orderBy=${orderBy}`;
    }
    return composeRequest(URL, 'GET', null);
};

export const getConversionJobs = (
    page: number,
    pageSize: number,
    searchTerm: string | null,
    selectedBusiness: string | number,
    selectedJobType: string | null,
    selectedStatus: string | null,
    orderBy?: string
) => {
    let URL = API_URLS.conversionJobsUrl + `?page=${page}&page_size=${pageSize}`;
    if (selectedBusiness) {
        URL = `${URL}&business=${selectedBusiness}`;
    }
    if (selectedJobType) {
        URL = `${URL}&job_type=${selectedJobType}`;
    }
    if (selectedStatus) {
        URL = `${URL}&status=${selectedStatus}`;
    }
    searchTerm = searchTerm ? searchTerm.trim() : '';
    if (searchTerm) {
        URL = `${URL}&search=${encodeURIComponent(searchTerm)}`;
    }
    if (orderBy) {
        URL = `${URL}&ordering=${orderBy}`;
    }
    return composeRequest(URL, 'GET', null);
};

export const retryConversionJob = (jobId: number) => {
    const URL = API_URLS.conversionJobsUrl + `${jobId}/retry/`;
    return composeRequest(URL, 'POST', JSON.stringify({}));
};